import * as Yup from "yup";
import { forceInt } from "Utils";

export const ImageKeywordValidationSchema = Yup.object().shape({});

export const ImageKeywordObjectSchema = {
    id: null,
    keyword: null,
    mlExtracted: null,
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let kw = Object.assign({}, ImageKeywordObjectSchema, {
        id: forceInt(requestData.id),
        keyword: requestData.keyword,
        mlExtracted: requestData.ml_extracted,
    });

    return kw;
}
